import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../components";
import isEmpty from "lodash.isempty";
import loader from "../../style/loader/loader.scss";
import { removeChildInvoices } from "../../redux/actions/invoicesActions";

const history = createHashHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {};

let invoiceDescription = [],
  invoiceQuantity = [],
  invoicePrice = [],
  totalInvoiceAmt = [],
  minQuantity = [];

class AdditionalPrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      indexKey: this.props.indexKey,
      priceData: this.props.priceData ? this.props.priceData : "",
      hideMsg: false,
    };
  }

  componentDidMount() {
     this.setState({});
  }

  componentWillMount() {

    if (this.state.priceData == "") {
      invoiceDescription[this.state.indexKey] = "";
      invoiceQuantity[this.state.indexKey] = "";
      invoicePrice[this.state.indexKey] = "";
      totalInvoiceAmt[this.state.indexKey] = "";
    }
    
  }

  componentWillReceiveProps(nextProps) {}

  removePriceDetail = e => {
    let getInvoicesID = e.target.attributes.getNamedItem("data-key").value;
    if (getInvoicesID != '') {
      this.props.removeChildInvoices(getInvoicesID);
      this.props.removePriceDetail(this.state.indexKey, getInvoicesID);
    }else{
      this.props.removePriceDetail(this.state.indexKey, getInvoicesID);
    }
  };

  handleinvoiceDescriptionChange = e => {
    invoiceDescription[this.state.indexKey] = e.target.value;
    this.props.handleinvoiceDescriptionChange(e.target.value, this.state.indexKey);
  };

  handleinvoiceQuantityChange = e => {
    const tAmount = e.target.value * (invoicePrice[this.state.indexKey]? invoicePrice[this.state.indexKey]: this.props.priceData.invoicePrice);
     totalInvoiceAmt[this.state.indexKey] = tAmount;
     this.props.handletotalInvoiceAmtChange(tAmount, this.state.indexKey);
    invoiceQuantity[this.state.indexKey] = e.target.value;
    this.props.handleinvoiceQuantityChange(e.target.value, this.state.indexKey);
    this.setState({tAmount: tAmount, invQty: e.target.value});
  };

  handleinvoicePriceChange = e => {
    const tAmount = e.target.value * (invoiceQuantity[this.state.indexKey]? invoiceQuantity[this.state.indexKey]: this.props.priceData.invoiceQuantity);
    totalInvoiceAmt[this.state.indexKey] = tAmount;
    this.props.handletotalInvoiceAmtChange(tAmount, this.state.indexKey);
    invoicePrice[this.state.indexKey] = e.target.value;
    this.props.handleinvoicePriceChange(e.target.value, this.state.indexKey);
    this.setState({tAmount: tAmount, invPrice : e.target.value});
  };

  handletotalInvoiceAmtChange = e => {
    totalInvoiceAmt[this.state.indexKey] = e.target.value;
    this.props.handletotalInvoiceAmtChange(e.target.value, this.state.indexKey);
  };

  handleUpdate = e => {     
    this.props.handleUpdate(e.target.name, e.target.value, this.state.indexKey);
    let value = '';
    if(e.target.name == 'invoicePrice'){
      value = (typeof this.state.invoiceQuantity == 'undefined') ? this.props.priceData.invoiceQuantity : this.state.invoiceQuantity;
      value = e.target.value * value;
      this.setState({tAmount: value, invoicePrice: e.target.value});
    }

    if(e.target.name == 'invoiceQuantity'){
      value = (typeof this.state.invoicePrice == 'undefined') ? this.props.priceData.invoicePrice : this.state.invoicePrice;
      value = e.target.value * value;
      this.setState({tAmount: value, invoiceQuantity: e.target.value});
    }
  };


  render() {
    //console.log('props', this.props.totalAmount, (typeof this.state.tAmount != 'undefined') ? this.state.tAmount : this.props.priceData.totalInvoiceAmt)
    return (
      <Row key={this.state.indexKey}>
        <div className="col-lg-12 add-sub-admin">
          {/**start invoices price information **/}
          <div className="panel">
            <header className="panel-heading">
              Invoice Details{" "}
              <Button
                bsSize="small"
                bsStyle="danger"
                className="pull-right"
                data-key={
                  this.state.priceData ? this.state.priceData.invoicesID : ""
                }
                onClick={this.removePriceDetail}
              >
                Remove
              </Button>
            </header>
            <div className="panel-body">
              <div className="add-invoices col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formInvoiceDescription">
                      <ControlLabel>
                        Description
                      </ControlLabel>
                      <FormControl
                        type="text"
                        defaultValue={
                          invoiceDescription[this.state.indexKey]
                            ? invoiceDescription[this.state.indexKey]
                            : this.props.priceData.invoiceDescription
                        }
                        placeholder="Invoice Description"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleinvoiceDescriptionChange
                        }
                        name="invoiceDescription"
                        style={{ borderColor: this.state.invoiceDescriptionError }}
                      />
                    </FormGroup>
                    
                    <ControlLabel>
                     Quantity
                    </ControlLabel>
                    <FormGroup controlId="formInvoiceQuantity">
                      <FormControl
                        type="number"
                        defaultValue={
                          invoiceQuantity[this.state.indexKey]
                            ? invoiceQuantity[this.state.indexKey]
                            : this.props.priceData.invoiceQuantity
                        }
                        placeholder="Invoice Quantity"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleinvoiceQuantityChange
                        }
                        name="invoiceQuantity"
                        style={{ borderColor: this.state.invoiceQuantityError }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <ControlLabel>
                       Price
                    </ControlLabel>
                    <FormGroup controlId="formInvoicePrice">
                      <FormControl
                        type="number"
                        defaultValue={
                          invoicePrice[this.state.indexKey]
                            ? invoicePrice[this.state.indexKey]
                            : this.props.priceData.invoicePrice
                        }
                        placeholder="Invoice Price"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleinvoicePriceChange
                        }
                        name="invoicePrice"
                        style={{ borderColor: this.state.invoicePriceError }}
                      />
                    </FormGroup>
                    <ControlLabel>
                       Total Amount
                    </ControlLabel>
                    <FormGroup controlId="formtotalInvoiceAmt">
                      <FormControl
                        type="number"
                        value={
                          (typeof this.state.tAmount != 'undefined') ? parseFloat(this.state.tAmount).toFixed(2) : parseFloat(this.props.priceData.totalInvoiceAmt).toFixed(2)
                        }
                        placeholder="Invoice Amount"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handletotalInvoiceAmtChange
                        }
                        name="totalInvoiceAmt"
                        style={{ borderColor: this.state.totalInvoiceAmtError }}
                        readOnly = "true"
                      />
                    </FormGroup>                     
                  </Col>
                </Row>               
              </div>
            </div>
          </div>
          {/**end contract price information **/}
        </div>
      </Row>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    deletedInvoices: state.invoicesReducers.deletedInvoices,
    error: state.invoicesReducers.error
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, { removeChildInvoices })
)(AdditionalPrice);



// WEBPACK FOOTER //
// ./src/app/views/invoices/AdditionalPrice.js